<tr class="wa-table__row visibility--hide-mobile">
  <td class="wa-table__cell wa-table__cell--fit-right">
    <div class="ranking" data-th="ranking" [ngClass]="{'ranking--square': true}">

      <lib-athlete-rank *ngIf="athlete" [rank]="athlete?.Rnk" [rankPrevious]="athlete?.Rnk"></lib-athlete-rank>
      <lib-athlete-photo *ngIf="athlete" [id]="athlete?.Athlete.Id" [isTeam]="false"></lib-athlete-photo>
    </div>
  </td>
  <td class="wa-table__cell">
    <div *ngIf="athlete" data-th="name">
      <lib-athlete-name *ngIf="athlete" [fname]="athlete?.Athlete.FName" [gname]="athlete?.Athlete.GName" [wnameord]="athlete?.Athlete.WNameOrd"
        [id]="athlete?.Athlete.Id"></lib-athlete-name>
    </div>
  </td>
  <td class="wa-table__cell">
    <div class="country">
      <lib-country-flag *ngIf="athlete" [id]="athlete?.Athlete.NOC"></lib-country-flag>

      <div class="country__name">
        {{ (getNameCountry(athlete?.Athlete.NOC))?.CName}}
      </div>
    </div>
  </td>
  <td class="wa-table__cell">
    <div class="score" data-th="points">
      {{ athlete?.Points }}
    </div>
  </td>
  <td class="wa-table__cell wa-table__cell--fit-left">
    <div class="list-row-item__action" (click)="onClick()">
      <span class="plus-minus {{showDetails === false ? 'plus-minus--more' : 'plus-minus--less' }}">
      </span>
    </div>
  </td>
</tr>
<div class="wa-table-simple visibility--hide-desktop">
  <div class="wa-table-simple__cell">
    <div class="wa-table-simple__cell__item">
      <div class="ranking" data-th="ranking" [ngClass]="{'ranking--square': true}">

        <lib-athlete-rank *ngIf="athlete" [rank]="athlete?.Rnk" [rankPrevious]="athlete?.Rnk"></lib-athlete-rank>
        <lib-athlete-photo *ngIf="athlete" [id]="athlete?.Athlete.Id" [isTeam]="false"></lib-athlete-photo>
      </div>
    </div>

  </div>
  <div class="wa-table-simple__cell wa-table-simple__cell">
    <div class="wa-table-simple__cell__item">

      <div *ngIf="athlete" data-th="name">
        <lib-athlete-name *ngIf="athlete" [fname]="athlete?.Athlete.FName" [gname]="athlete?.Athlete.GName" [wnameord]="athlete?.Athlete.WNameOrd"
          [id]="athlete?.Athlete.Id"></lib-athlete-name>
      </div>

      <div class="country">

        <lib-country-flag *ngIf="athlete" [id]="athlete?.Athlete.NOC"></lib-country-flag>

        <div class="country__name">
          {{ (getNameCountry(athlete?.Athlete.NOC))?.CShort}}
        </div>
      </div>
    </div>
  </div>
  <div class="wa-table-simple__cell wa-table-simple__cell--right">

    <div class="wa-table-simple__cell__item">
      <div class="score score--extra-small" data-th="points">
        {{ athlete?.Points }}
      </div>
    </div>
    <div class="wa-table-simple__cell__item">
      <div class="list-row-item__action" (click)="onClick()">
        <span class="plus-minus {{showDetails === false ? 'plus-minus--more' : 'plus-minus--less' }}">
        </span>
      </div>
    </div>
  </div>
</div>
<tr (click)="onClick()" class="wa-table__row wa-table__row--simple">
  <td class="wa-table__cell wa-table__cell--fit" colspan="100%">

    <app-price-for-precision-details [details]="athlete.Details" *ngIf="showDetails === true"></app-price-for-precision-details>
  </td>
</tr>
